/**
 * @param {ApiParamsPage} params
 * @returns {URLSearchParams}
 */
export const createUrlParams = ({ token, pageNumber, pageSize, query }) => {
    const params = {
        token,
        take: pageSize,
        skip: (pageNumber - 1) * pageSize
    };

    if (query) {
        Object.assign(params, {
            'filter[filters][0][value]': query,
            'filter[filters][0][field]': 'n',
            'filter[filters][0][operator]': 'contains',
            'filter[filters][0][ignoreCase]': true,
            'filter[logic]': 'and'
        });
    }

    return new URLSearchParams(params);
};


/**
 * @param {string} url
 * @param {ApiParamsItemIndex} params
 * @param {AbortSignal} [signal]
 * @returns {Promise<ApiResponseData>}
 */
export const fetchItemIndex = async (url, params, signal) => {
    const { id, token } = params;
    const body = new URLSearchParams({
        token,
        id,
        ix: true
    });

    const response = await fetch(url, {
        method: 'POST',
        body,
        headers: {
            Accept: 'application/json, text/javascript, */*; q=0.01'
        },
        signal
    });

    if (!response.ok) {
        throw new Error(
            `Could not fetch from API (params=${JSON.stringify(params)}): ${response.status} ${
                response.statusText
            }`
        );
    }

    return response.json();
};

/**
 * @param {string} url
 * @param {ApiParamsPage} params
 * @param {AbortSignal} [signal]
 * @returns {Promise<ApiResponseData>}
 */
export const fetchApiPage = async (url, params, signal) => {
    const body = createUrlParams(params);

    const response = await fetch(url, {
        method: 'POST',
        body,
        headers: {
            Accept: 'application/json, text/javascript, */*; q=0.01'
        },
        signal
    });

    if (!response.ok) {
        throw new Error(
            `Could not fetch from API (params=${JSON.stringify(params)}): ${response.status} ${
                response.statusText
            }`
        );
    }

    return response.json();
};

/**
 * @typedef {object} ApiParamsItemIndex
 * @prop {string} token
 * @prop {string} id
 */

/**
 * @typedef {object} ApiParamsPage
 * @prop {string} token
 * @prop {import("./pagination").PageNumber} pageNumber
 * @prop {import("./pagination").PageSize} pageSize
 * @prop {string} [query]
 */

/**
 * @typedef {object} ApiResponseData
 * @prop {import("./items").RawPlanPickerItem[]} data
 * @prop {number} total
 */
